import { cn } from '@/lib/utils'

/**
 * The Tapwork mark on a white squircle tile.
 *
 * The mark's own artwork is a blue-violet gradient, which loses contrast on the indigo sidebar;
 * a white tile behind the transparent mark keeps it crisp on any background. The squircle is a
 * true superellipse-style curve (an SVG mask), not a rounded square, so it reads as an app icon.
 */
const SQUIRCLE = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath d='M50 0C88 0 100 12 100 50s-12 50-50 50S0 88 0 50 12 0 50 0z'/%3E%3C/svg%3E\")"

export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      className={cn('grid size-11 shrink-0 place-items-center bg-white shadow-sm', className)}
      style={{ maskImage: SQUIRCLE, WebkitMaskImage: SQUIRCLE, maskSize: '100% 100%', WebkitMaskSize: '100% 100%' }}
    >
      <img src="/brand/tapwork-mark.png" alt="" className="w-[68%]" />
    </span>
  )
}
